import { combineReducers } from 'redux';
import { reducer as toastrReducer } from 'react-redux-toastr';

import AuthReducer from './reducers/authReducer';
import WrapperReducer from './reducers/wrapper';
import MenuReducer from './reducers/menu';
import DialogReducer from './reducers/dialog';
import UsuarioReducer from './reducers/usuario';
import FuncionarioReducer from './reducers/funcionario';
import ProdutoReducer from './reducers/produto';
import VendasReducer from './reducers/vendas';
import CategoriaReducer from './reducers/categoria';
import EstadoReducer from './reducers/estado';
import CidadeReducer from './reducers/cidade';
import DashboardReducer from './reducers/dashboard';
import persistedNegocioReducer from './reducers/persistedNegocioReducer';
import EnderecoReducer from './reducers/endereco';
import Notificacoes from './reducers/notificacoes';
import Perguntas from './reducers/pergunta';
import Publicidade from './reducers/publicidade';
import VersaoAppReducer from './reducers/versaoApp';
import CupomDeDescontoReducer from './reducers/cupomDeDesconto';
import PagamentosReducer from './reducers/pagamentos';
import FreteReducer from './reducers/frete';
import NotificacoesPushReducer from './reducers/notificacoesPush';

const rootReducer = combineReducers({
    auth: AuthReducer,
    wrapper: WrapperReducer,
    menu: MenuReducer,
    dialog: DialogReducer,
    toastr: toastrReducer,
    usuario: UsuarioReducer,
    funcionario: FuncionarioReducer,
    produto: ProdutoReducer,
    venda: VendasReducer,
    negocio: persistedNegocioReducer,
    categoria: CategoriaReducer,
    estado: EstadoReducer,
    cidade: CidadeReducer,
    dashboard: DashboardReducer,
    endereco: EnderecoReducer,
    notificacoes: Notificacoes,
    perguntas: Perguntas,
    publicidade: Publicidade,
    versaoApp: VersaoAppReducer,
    cupomDeDesconto: CupomDeDescontoReducer,
    pagamentos: PagamentosReducer,
    notificacoesPush: NotificacoesPushReducer,
    frete: FreteReducer
})

export default rootReducer